import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useSidebar } from '@/theme/components/ui/sidebar';

/**
 * Auto-closes the mobile sidebar drawer on route change. Must be rendered
 * inside a SidebarProvider. Keeps the drawer open on desktop.
 */
export function MobileDrawerAutoClose() {
  const { isMobile, setOpenMobile } = useSidebar();
  const { pathname } = useLocation();

  useEffect(() => {
    if (isMobile) {
      setOpenMobile(false);
    }
  }, [pathname, isMobile, setOpenMobile]);

  return null;
}

export default MobileDrawerAutoClose;
